import * as PropTypes from 'prop-types';
import React from 'react';

import {
  STAGE_CONFIGURATION_FULL_SHAPE,
  StageConfiguration,
  WORKFLOW_STAGE_FULL_SHAPE,
  WorkflowStage,
} from 'workflows/WorkflowConstants';

import StageMenu from './StageMenu';

function StageHeaderCell(props: StageHeaderCellProps): JSX.Element {
  return (
    <div className="workflowDetailsTable-stageHeaderCell">
      <div
        className="stageHeaderCell-name"
        onClick={(e) => {
          props.onSetIsStageCollapsed(!props.isStageCollapsed);
        }}
      >
        {props.workflowStage.name}
      </div>
      {props.workflowStage.permissions.writable && <StageMenu {...props} />}
    </div>
  );
}

interface StageHeaderCellProps {
  baseWorkflowTemplateVersionId: string | null;
  onBulkCreateStageRuns: (stageConfiguration: StageConfiguration) => void;
  onBulkSplitStageRuns: (workflowStage: WorkflowStage) => void;
  onCreate: (workflowStage: WorkflowStage) => void;
  onSetIsStageCollapsed: (newIsStageCollapsed: boolean) => void;
  isStageCollapsed: boolean;
  stageConfiguration: StageConfiguration;
  workflowStage: WorkflowStage;
}

StageHeaderCell.propTypes = {
  baseWorkflowTemplateVersionId: PropTypes.string,
  onBulkCreateStageRuns: PropTypes.func.isRequired,
  onBulkSplitStageRuns: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onSetIsStageCollapsed: PropTypes.func,
  isStageCollapsed: PropTypes.bool,
  stageConfiguration: STAGE_CONFIGURATION_FULL_SHAPE.isRequired,
  workflowStage: WORKFLOW_STAGE_FULL_SHAPE.isRequired,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

export default StageHeaderCell;
